import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {makeStyles} from "@mui/styles";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {AccountStoreSettingDto, FileDto} from "../../../../../../../dtos";
import {Box, Button, Typography} from "@mui/material";
import {PageSpinner} from "../../../../../../com/pagesTab/pagesSpinner/spinner";
import Draggable from "react-draggable";
import {PopupHeader} from "../../../../../../com/popupHeader/popupHeader";
import {
    deleteStoreSettingForAccount,
    getStoreSettingForAccount, saveStoreSettingForAccount, setDefaultStoreSettingForAccount
} from "../../../../../../../store/actionCreators/accountStoreSettingsActionCreators";
import StoreSettingsTable from "./storeSettingsTable";
import StoreSettingCreateEditPopup from "./storeSettingCreateEditPopup/storeSettingCreateEditPopup";


const useStyles = makeStyles(() => ({
    storeSettingsPopupWrapperContainer: {
        position: "absolute",
        zIndex: 1061,
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "#00000080",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    storeSettingsPopup: {
        width: `880px`,
        backgroundColor: `#ffffff`,
        maxHeight: `98vh`,
        display: `flex`,
        flexFlow: `column`,
        "& .MuiInputBase-input": {
            padding: `5px`,
            height: `20px`,
        },
    },
    storeSettingsPopupContentWrapper: {
        padding: "20px",
    },
    selectedStoreSettingCaption: {},
    controlsRowWrapper: {
        marginBottom: "20px",
        display: "flex",
        flexFlow: "row",
        columnGap: "80px",
        '& > .MuiButton-root': {
            padding: "8px",
            background: "linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)",
            color: "#FFFFFF",
            borderRadius: "2px"
        }
    },
    selectedStoreSettingCaptionWrapper: {
        display: "flex",
        flexFlow: "row",
        columnGap: "8px",
        alignItems: "center"
    },
}))


interface Props {
    onHide: () => void;
}

const StoreSettingsPopup: React.FC<Props> = ({
                                                 onHide
                                             }) => {
    const dispatch = useDispatch();
    const {accountStoreSettings} = useTypedSelector((state) => state);
    const classes = useStyles();
    const [storeSettings, setStoreSettings] = useState<AccountStoreSettingDto[]>([]);
    const [showStoreSettingPopup, setShowStoreSettingPopup] = useState(false);
    const [currentStoreSettingData, setCurrentStoreSettingData] = useState<AccountStoreSettingDto>({});


    useEffect(() => {
        dispatch(getStoreSettingForAccount());
        return () => {

        };
    }, []);

    useEffect(() => {
        setStoreSettings(accountStoreSettings.storeSettings);
    }, [accountStoreSettings.type]);


    const handleEditRow = (storeSettingData: AccountStoreSettingDto) => {
        setCurrentStoreSettingData(storeSettingData)
        setShowStoreSettingPopup(true);
    }

    const handleDeleteRow = (storeSettingData: AccountStoreSettingDto) => {
        setShowStoreSettingPopup(false);
        dispatch(deleteStoreSettingForAccount(storeSettingData.id!, storeSettings));
    }

    const setDefaultSettingForStore = (storeSettingData: AccountStoreSettingDto) => {
        setShowStoreSettingPopup(false);
        dispatch(setDefaultStoreSettingForAccount(storeSettingData.id!, storeSettings));
    }

    const handleSaveForStoreSettingPopup = (storeSettingData: AccountStoreSettingDto, backgroundFile: FileDto | null, logoFile: FileDto | null) => {
        dispatch(saveStoreSettingForAccount(storeSettingData, storeSettings, backgroundFile, logoFile));
        // setShowStoreSettingPopup(false);
    }

    const createNewStoreSetting = () => {
        setCurrentStoreSettingData({});
        setShowStoreSettingPopup(true);
    }


    return (
        <Box
            className={classes.storeSettingsPopupWrapperContainer}
        >
            <Draggable
                bounds="body"
                handle={`.draggable_header_store_settings_popup`}
                defaultPosition={{x: 0, y: -50}}
            >
                <Box className={classes.storeSettingsPopup}>
                    {accountStoreSettings.loading &&
                        <Box
                            sx={{
                                position: "absolute",
                                zIndex: "2",
                                height: "100%",
                                width: "100%",
                                backgroundColor: "#e4e4e4a1",
                                display: `flex`,
                                alignItems: `center`,
                                justifyContent: `center`,
                            }}
                        >
                            <PageSpinner/>
                        </Box>
                    }
                    <PopupHeader
                        headerCaption={"Store Settings"}
                        onClose={onHide}
                        bg={"linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)"}
                        jc={"flex-start"}
                        classForHeader={"draggable_header_store_settings_popup"}
                    />
                    <Box className={classes.storeSettingsPopupContentWrapper}>
                        <Box className={classes.controlsRowWrapper}>
                            <Button onClick={createNewStoreSetting}>
                                <Typography>
                                    + New Store Settings
                                </Typography>
                            </Button>
                            {/*<Box className={classes.selectedStoreSettingCaptionWrapper}>*/}
                            {/*    <Typography fontWeight={700}>*/}
                            {/*        Current store style:*/}
                            {/*    </Typography>*/}
                            {/*    <Typography className={classes.selectedStoreSettingCaption}>*/}
                            {/*        Some setting*/}
                            {/*    </Typography>*/}
                            {/*</Box>*/}
                        </Box>
                        <StoreSettingsTable
                            storeSettingArray={storeSettings}
                            onEdit={handleEditRow}
                            onDelete={handleDeleteRow}
                            setDefaultSettingForStore={setDefaultSettingForStore}
                        />
                    </Box>
                    {/*<StoreSettingPopupContent/>*/}
                </Box>
            </Draggable>
            {
                showStoreSettingPopup &&
                <StoreSettingCreateEditPopup
                    show={showStoreSettingPopup}
                    onHide={() => setShowStoreSettingPopup(false)}
                    storeSetting={currentStoreSettingData}
                    onSave={handleSaveForStoreSettingPopup}
                />
            }
        </Box>
    )
}

export default StoreSettingsPopup;